// extracted by mini-css-extract-plugin
module.exports = {"icon":"_6c97079b1b--icon--KRi_H","icon--small":"_6c97079b1b--icon--small--GBBpq","icon--3":"_6c97079b1b--icon--3--Vvj3n","icon--4":"_6c97079b1b--icon--4--IOMrn"};